import React from 'react';

import { SVGComponentProps } from './svg.types';

const DragSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps): JSX.Element => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 8 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <circle cx="1.5" cy="2" r="1.5" fill={fill} />
        <circle cx="6.5" cy="2" r="1.5" fill={fill} />
        <circle cx="1.5" cy="7" r="1.5" fill={fill} />
        <circle cx="6.5" cy="7" r="1.5" fill={fill} />
        <circle cx="1.5" cy="12" r="1.5" fill={fill} />
        <circle cx="6.5" cy="12" r="1.5" fill={fill} />
      </svg>
    </span>
  );
};

export default DragSVG;
